import React from 'react';

import * as styles from './styles';
import {
  TableSortLabel as MuiTableSortLabel,
  type TableSortLabelProps as MuiTableSortLabelProps,
  withStyles,
} from '@material-ui/core';

import { ArrowDownIcon, ArrowUpIcon, SortArrowsIcon } from '../../icons';

import { colors, fonts } from '../../styles';

const StyledTableSortLabel = withStyles({
  root: {
    color: colors.gray.dark,
    fontWeight: fonts.weight.medium,
    flexDirection: 'row',
    letterSpacing: 'normal',
    '&:hover': {
      color: colors.gray.dark,
    },
    '& svg': {
      marginLeft: 5,
    },
    '& > *': {
      flexShrink: 0,
    },
  },
  active: {
    '&&': {
      color: colors.gray.dark,
    },
  },
})(MuiTableSortLabel);

export interface TableSortLabelProps extends MuiTableSortLabelProps {
  sortable?: boolean;
}

export const TableSortLabel = React.forwardRef<
  HTMLSpanElement,
  TableSortLabelProps
>(({ sortable, ...props }, ref) => {
  const { active, direction } = props;

  const ArrowIcon = () => {
    if (!sortable) {
      return null;
    }

    if (active) {
      return direction === 'asc' ? <ArrowUpIcon /> : <ArrowDownIcon />;
    }

    return <SortArrowsIcon />;
  };

  return (
    <StyledTableSortLabel
      ref={ref}
      IconComponent={ArrowIcon}
      className={styles.sortableColumn(sortable)}
      {...props}
    />
  );
});
